import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import AppShell from '../layouts/AppShell';
import Home from '../pages/Home';
import ShareReceive from '../pages/ShareReceive';
import { resumeLastScreen } from '../utils/lastScreen';
import { lazyPage } from '../utils/lazyPage';

// 앱이 열리는 두 입구(홈, 공유받은 문장)만 바로 싣고, 나머지는 들어갈 때 불러온다.
// 통계의 차트(recharts)와 기록의 마크다운(react-markdown)이 특히 무겁다 (utils/lazyPage)
const Library = lazyPage(() => import('../pages/Library'));
const BookDetail = lazyPage(() => import('../pages/BookDetail'));
const Stats = lazyPage(() => import('../pages/Stats'));
const AddBook = lazyPage(() => import('../pages/AddBook'));
const Settings = lazyPage(() => import('../pages/Settings'));

// 휴대폰이 꺼버린 앱을 다시 열면 보던 화면으로 돌아간다.
// 라우터는 만들어지는 순간의 주소로 시작하므로 반드시 createBrowserRouter 보다 먼저 부른다
resumeLastScreen();

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Home /> },
      { path: 'library', element: <Library /> },
      { path: 'book/:id', element: <BookDetail /> },
      { path: 'stats', element: <Stats /> },
      { path: 'add', element: <AddBook /> },
      { path: 'settings', element: <Settings /> },
      // 안드로이드 공유 목록에서 북러닝을 고르면 오는 화면 (vite.config.js 의 share_target)
      { path: 'share', element: <ShareReceive /> },
      { path: '*', element: <Navigate to="/" replace /> }
    ]
  }
]);
